import tim from '../../tim'
const user = {
  state: {
    currentUserProfile: {},
    isLogin: false,
    isSDKReady: false, // TIM SDK 是否 ready
    isAllow: false, 
    userID: 0,
    avatar:  null,
    nickname: null,
    userSig: '',
    sdkAppID: 0,
    color:'',
    enterid:'',
    anonymity:false,
	importState:false,
	pageVisibleOrHidden:'hidden',
	headimgurl:'',//用户头像
    zhujianAppId: ''
  },
  mutations: {
    setNickname(state,nickname){
      state.nickname = nickname
    },
    setEnterID(state,enterid, zhujianAppId){
      state.enterid = enterid
    },
    setZhujian(state,zhujianAppId){
      state.zhujianAppId = zhujianAppId
    },
    setPageVisibleOrHidden(state,pageVisibleOrHidden){
      state.pageVisibleOrHidden = pageVisibleOrHidden
    },
    setAnonymity(state,anonymity){
      state.anonymity = anonymity
    },
    updateCurrentUserProfile(state, userProfile) {
      state.currentUserProfile = userProfile
    },
    toggleIsLogin(state, isLogin) {
      state.isLogin = typeof isLogin === 'undefined' ? !state.isLogin : isLogin
    },
    toggleIsSDKReady(state, isSDKReady) {
      state.isSDKReady = typeof isSDKReady === 'undefined' ? !state.isSDKReady : isSDKReady
    },
    toggleIsAllow(state, isAllow) {
      state.isAllow = typeof isAllow === 'undefined' ? !state.isAllow : isAllow
    },
    color(state, color) {
      state.color = typeof color === 'undefined' ? '000' : color
    },
    importState(state, importState) {
      state.importState = typeof importState === 'undefined' ? false : importState
    },
    reset(state) {
      Object.assign(state, {
        currentUserProfile: {},
        isLogin: false,
        isSDKReady: false, // TIM SDK 是否 ready
        isAllow: false,
      })
    },
    setUserInfo(state, payload) {
      state.userID = payload.userID
      state.headimgurl = payload.headimgurl
      state.userSig = payload.userSig
      state.sdkAppID = payload.sdkAppID
    },
  },
  actions: {
    logout(context) {
      // 若有当前会话，在退出登录时已读上报
      if (context.rootState.conversation.currentConversation.conversationID) {
        tim.setMessageRead({ conversationID: context.rootState.conversation.currentConversation.conversationID })
      }
      tim.logout().then(() => {
        context.commit('toggleIsLogin')
        context.commit('stopComputeCurrent')
        context.commit('reset')
      })
    }
  }
}

export default user
